// @file List row separators, in a module of their own so a caller can pick a separator without
// importing the component into its chunk.

export enum OzListRowSeparator {
  None = 'none',
  Short = 'short',
  Long = 'long',
  FullWidth = 'full-width',
}
